import React, { useEffect } from "react";
import CourseBanner from "../components/CourseBanner";

/**
 * BUNDLE SUCCESS PAGE — /sample-success
 *
 * Lands here after a visitor submits their email on /book#free-chapter.
 * Delivers BOTH free gifts:
 *   1. 8-page book sample PDF
 *   2. 12-Month I GET TO Calendar PDF
 *
 * Page is noindex (we don't want Google indexing it) and gives the
 * downloads immediately so the visitor doesn't wait for email delivery.
 */

const BRAND = {
  deep: "#042F2E",
  teal: "#068fa2",
  light: "#7BC8CB", // OCEAN Light Teal (was gold #d4af6a — retired 2026-06-28)
  cream: "#efeae7",
  mint: "#5EEAD4",
};

const SAMPLE_PDF_URL = "/downloads/MBSH-Sample-Pages-1-8-2026.pdf";
const CALENDAR_PDF_URL = "/downloads/I-GET-TO-Calendar-2026.pdf";

const SampleSuccessPage = () => {
  useEffect(() => {
    document.title = "Your free gifts are here · Temple Franklin";

    // Don't let Google index this page
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, nofollow");

    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "sample_success_view");
    }

    return () => {
      const stale = document.querySelector('meta[name="robots"]');
      if (stale) stale.remove();
    };
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6 py-16"
      style={{
        background: `linear-gradient(160deg, ${BRAND.deep} 0%, ${BRAND.teal} 100%)`,
        color: BRAND.cream,
      }}
      data-testid="sample-success-page"
    >
      <div className="max-w-2xl w-full text-center">
        <p
          className="font-sans text-xs tracking-[0.4em] uppercase mb-5"
          style={{ color: BRAND.light }}
          data-testid="success-eyebrow"
        >
          You're on the list ✦
        </p>

        <h1
          className="font-serif tracking-tight leading-[1.05] mb-6"
          style={{ fontSize: "clamp(2.4rem, 5vw, 3.8rem)" }}
          data-testid="success-headline"
        >
          Your <span style={{ color: BRAND.mint, fontStyle: "italic" }}>two free gifts</span> are here.
        </h1>

        <p
          className="font-serif italic text-xl md:text-2xl leading-relaxed mb-10 max-w-xl mx-auto"
          style={{ color: `${BRAND.cream}dd` }}
          data-testid="success-lede"
        >
          The first 8 pages of the book — and the 12-Month I GET TO Calendar. Download both right now, hold them, and sit with them.
        </p>

        {/* Two download buttons side-by-side on desktop, stacked on mobile */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-10">
          <a
            href={SAMPLE_PDF_URL}
            download="MBSH-Sample-Pages-1-8.pdf"
            className="inline-flex items-center justify-center gap-3 px-7 py-5 rounded-full font-sans font-semibold tracking-wide transition-all hover:scale-[1.02] hover:shadow-2xl w-full sm:w-auto"
            style={{ background: BRAND.mint, color: BRAND.deep, fontSize: "15px" }}
            data-testid="download-sample-cta"
            onClick={() => {
              if (typeof window !== "undefined" && typeof window.gtag === "function") {
                window.gtag("event", "download_sample_pdf");
              }
            }}
          >
            Download the 8-page sample ↓
          </a>
          <a
            href={CALENDAR_PDF_URL}
            download="I-GET-TO-Calendar-2026.pdf"
            className="inline-flex items-center justify-center gap-3 px-7 py-5 rounded-full font-sans font-semibold tracking-wide transition-all hover:scale-[1.02] hover:shadow-2xl w-full sm:w-auto border-2"
            style={{
              background: "transparent",
              color: BRAND.cream,
              borderColor: BRAND.cream,
              fontSize: "15px",
            }}
            data-testid="download-calendar-cta"
            onClick={() => {
              if (typeof window !== "undefined" && typeof window.gtag === "function") {
                window.gtag("event", "download_calendar_pdf");
              }
            }}
          >
            Download the calendar ↓
          </a>
        </div>

        <div
          className="p-7 rounded-2xl max-w-xl mx-auto"
          style={{
            background: `${BRAND.cream}11`,
            border: `1px solid ${BRAND.light}44`,
          }}
          data-testid="success-followup"
        >
          <p
            className="font-sans text-xs tracking-[0.3em] uppercase font-semibold mb-3"
            style={{ color: BRAND.light }}
          >
            What happens next
          </p>
          <p
            className="font-serif italic text-base leading-relaxed"
            style={{ color: `${BRAND.cream}cc` }}
          >
            Check your inbox — I'm sending you the same two download links so you can find them again (and so you don't lose the calendar mid-March). After that, you'll get my weekly walk-with-me emails. Real tools. Real women. In the messy middle.
          </p>
          <p
            className="font-serif italic text-base leading-relaxed mt-4"
            style={{ color: BRAND.mint }}
          >
            — Temple
          </p>
        </div>

        <a
          href="/book"
          className="inline-block mt-10 font-sans text-sm tracking-wide underline-offset-4 hover:underline"
          style={{ color: `${BRAND.cream}aa` }}
          data-testid="back-to-book-link"
        >
          ← Back to the book page
        </a>

        {/* Upsell: $11.11 I GET TO Bundle */}
        <div className="mt-12">
          <CourseBanner product="bundle" variant="card" testId="sample-success-course-upsell" />
        </div>
      </div>
    </div>
  );
};

export default SampleSuccessPage;
